import { Controller } from "@hotwired/stimulus"

// Makes a whole card clickable to navigate to a URL while letting inner
// actions (links, buttons, status pills) keep their own click behavior.
//
// Usage:
//   <div data-controller="card-click"
//        data-action="click->card-click#navigate"
//        data-card-click-href-value="/foo">
//     ...
//     <a data-action="click->card-click#stop">Findings</a>
//   </div>
export default class extends Controller {
  static values = { href: String }

  navigate() {
    if (!this.hrefValue) return
    Turbo.visit(this.hrefValue, { frame: "_top" })
  }

  stop(event) {
    event.stopPropagation()
  }
}
